"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const clsx_1 = __importDefault(require("clsx"));
const TableBody_1 = require("./TableBody");
const TableHead_1 = require("./TableHead");
const TableRow_1 = require("./TableRow");
const TableData_1 = require("./TableData");
const react_1 = __importDefault(require("react"));
function Table({ testId, className, children }) {
    return (react_1.default.createElement("table", { className: (0, clsx_1.default)('min-w-full divide-y divide-borderColor', className), "data-testid": testId }, children));
}
exports.Table = Table;
Table.Head = TableHead_1.TableHead;
Table.Body = TableBody_1.TableBody;
Table.Row = TableRow_1.TableRow;
Table.Data = TableData_1.TableData;
//# sourceMappingURL=Table.js.map